import React, { Suspense } from "react";
import ReactDOM from 'react-dom';
import App from './App';
import './i18n.js';
import CartProvider from "./container/frontend/layout/cartContext.js";

// Suppress third-party library warnings in strict mode
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('UNSAFE_componentWillReceiveProps') ||
     args[0].includes('ReactOwlCarousel') ||
     args[0].includes('Legacy context API') ||
     args[0].includes('RevealBase'))
  ) {
    return;
  }
  originalError.call(console, ...args);
};

ReactDOM.render(
  // <Suspense fallback={<div>Loading...</div>}> 
  <React.StrictMode>
    <CartProvider>
        <App />
    </CartProvider>
  </React.StrictMode>,
  // </Suspense>

  document.getElementById('root')
);
